import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Solution = ({ listSolution }) => {
    return (
        <div className="teboil-solution">
            <FullWrapper>
                <div className="teboil-solutionWrapper">
                    <div className="teboil-solutionTitle">Решение</div>
                    <div className="teboil-solutionInner">
                        <div className="teboil-solutionLeft">
                            Для работы с&nbsp;проектом Teboil сформировали команду, которая уже
                            имеет опыт разработки крупных e-commerce проектов. Эта экспертиза
                            позволила значительно сократить сроки по&nbsp;проектированию
                            и&nbsp;внедрению интернет-магазина для Teboil, избежать многих ошибок,
                            которые могли&nbsp;бы возникнуть при создании сайта с&nbsp;нуля. Опыт
                            и&nbsp;знания команды также позволили улучшить качество
                            и&nbsp;функциональность проекта.
                        </div>
                        <div className="teboil-solutionRight">
                            Наша экспертиза позволила значительно сократить сроки
                            по&nbsp;проектированию и&nbsp;внедрению интернет-магазина для Teboil.
                        </div>
                    </div>
                    <div className="teboil-solutionContainer">
                        <div className="teboil-solutionSubtitle">Этапы разработки:</div>
                        {listSolution.map((item, index) => (
                            <div className="teboil-solutionList" key={index}>
                                <div className="teboil-solutionListNumber">{item.number}</div>
                                <div
                                    className="teboil-solutionListText"
                                    dangerouslySetInnerHTML={{ __html: item.text }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Solution;
